

const TimeCharge = () => null;

export default TimeCharge;
